import { adaptOldTask } from "./oldTask";

// Due to webpack v4
export { adaptOldTask };

import {
    LabelProgressMessage,
    ProgressProgressMessage,
    ErrorProgressMessage,
    StartProgressMessage,
    ShowTimeProgressMessage,
    PauseProgressMessage,
    ContinueProgressMessage,
    ProgressMessage,
    ProgressObserver,
    ProgressSubject,
} from "@archipad-js/core/progress";

import {
    makeProgressHandler,
    LegacyHandler as Handler,
} from "@core/tasks/oldTask";

export {
    LabelProgressMessage,
    ProgressProgressMessage,
    ErrorProgressMessage,
    StartProgressMessage,
    ShowTimeProgressMessage,
    PauseProgressMessage,
    ContinueProgressMessage,
    ProgressSubject,
    Handler,
    makeProgressHandler,
};

export type { ProgressMessage };
export type { ProgressObserver };
